import {memo} from 'react';
import {AcademyData} from '@/map/@types';
import {AROUND_DATA_OPTIONS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {NearbyInfoMarker} from './Marker';

interface IProps extends naver.maps.MarkerOptions {
  item: AcademyData & {
    overlapped?: AcademyData[];
  };
}

export const AcademyMarker = memo(
  ({map, position, item}: IProps) => {
    const overlapped = item.overlapped ?? [];
    const name = [item.name, ...overlapped.map((i) => i.name)];

    return (
      <NearbyInfoMarker
        typeInfo={AROUND_DATA_OPTIONS[AreaAnalyticsFilter.ACADEMY]}
        config={{
          map,
          position,
        }}
        detailBoxMaxHeight={200}
        item={{
          name,
          badgeCount: overlapped.length,
        }}
      />
    );
  },
  (prevProps: IProps, nextProps: IProps) => {
    return prevProps.position.toString() === nextProps.position.toString();
  }
);
